/**
 * The other ways in beside email, as the sign-in page (web/src/auth) and
 * /get-started's step 4 both offer them. One copy of the names and labels,
 * so the two read the same. No imports: the public pages' bundle takes it.
 */

export type Provider = 'google' | 'apple';

/** Which form: signing in to an account, or making one. */
export type AuthMode = 'signin' | 'signup';

/** The three ways in: a provider, or an emailed code. */
export type Method = Provider | 'email';

export const PROVIDERS: readonly Provider[] = ['google', 'apple'];

export const PROVIDER_NAME = { google: 'Google', apple: 'Apple' } as const;

export function providerLabel(provider: Provider, connecting: boolean): string {
  const name = PROVIDER_NAME[provider];
  return connecting ? `Connecting to ${name}…` : `Continue with ${name}`;
}

/** Clerk's name for each provider's OAuth strategy. */
export const PROVIDER_STRATEGY = {
  google: 'oauth_google',
  apple: 'oauth_apple',
} as const;
